import { Store } from '@ngrx/store';
// Actions
import { setModelPortfolioToPushToIRebal } from 'apps/model_portfolios/static/model_portfolios/ts/shared/features/irebal-push-modal/state/model-portfolio-to-push-to-irebal/model-portfolio-to-push-to-irebal.action';
// Services
import { SchwabIntegrationService } from 'apps/integrations/static/integrations/ts/services/schwab-integration-service';
// Constants
import { IREBAL_BLENDED_MODEL, IREBAL_MODEL } from 'apps/integrations/static/integrations/ts/constants';
import { IREBAL_PUSH_ERROR_MESSAGES } from 'ModelPortfolioApp/ts/shared/apps/model-portfolios-list-app/constants';
import * as i0 from "@angular/core";
import * as i1 from "apps/integrations/static/integrations/ts/services/schwab-integration-service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
const _c0 = a0 => ({ "is-invalid": a0 });
function IRebalPushModal_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 8);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Pushing portfolio to iRebal...");
} }
function IRebalPushModal_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const error_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("- ", error_r1, "");
} }
function IRebalPushModal_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1, " Some error occured while pushing the portfolio to iRebal: ");
    i0.ɵɵtemplate(2, IRebalPushModal_div_5_div_2_Template, 3, 1, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.errors);
} }
function IRebalPushModal_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 13);
    i0.ɵɵtext(2, "Select a name for the new portfolio in iRebal.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelement(4, "div", 14);
    i0.ɵɵelementStart(5, "input", 15);
    i0.ɵɵlistener("focus", function IRebalPushModal_div_6_Template_input_focus_5_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.isOpen); });
    i0.ɵɵtwoWayListener("ngModelChange", function IRebalPushModal_div_6_Template_input_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.portfolioName, $event) || (ctx_r1.portfolioName = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function IRebalPushModal_div_6_Template_input_ngModelChange_5_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.validatePortfolioName()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("placeholder", ctx_r1.placeholder);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.portfolioName);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, !ctx_r1.isValid));
} }
function IRebalPushModal_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" The portfolio was successfully pushed to iRebal. A new ", ctx_r1.portfolioType, " has been created with ID ", ctx_r1.iRebalPortfolioID, " ");
} }
export class IRebalPushModal {
    constructor(schwabIntegrationService, store) {
        this.schwabIntegrationService = schwabIntegrationService;
        this.store = store;
        this.errors = null;
        this.isOpen = false;
        this.isValid = true;
        this.loading = false;
        this.placeholder = '';
        this.portfolioName = null;
        this.modelPortfolioToPush = null;
        this.pushPortfolioResult = null;
        this.mapStateToComponent = (state) => {
            this.modelPortfolioToPush = state.modelPortfolioToPushToIRebal;
            if (this.modelPortfolioToPush) {
                this.isOpen = true;
                this.resetModal();
                this.portfolioName = `${this.modelPortfolioToPush.name} (${this.modelPortfolioToPush.security_object.security_id})`;
            }
        };
        this.storeSubscription = this.store.select('iRebalPushModal').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    resetModal() {
        this.errors = null;
        this.loading = false;
        this.pushPortfolioResult = null;
    }
    openModal() {
        if (this.modelPortfolioToPush)
            this.isOpen = true;
    }
    closeModal() {
        this.isOpen = false;
        this.pushPortfolioResult = null;
        this.store.dispatch(setModelPortfolioToPushToIRebal({ modelPortfolio: null }));
    }
    validatePortfolioName() {
        this.isValid = this.portfolioName != null && this.portfolioName.length > 0;
    }
    submit() {
        if (this.modelPortfolioToPush && this.portfolioName) {
            this.loading = true;
            this.schwabIntegrationService
                .postSchwabPushModel(this.modelPortfolioToPush.security_object.security_id, this.portfolioName)
                .subscribe({
                next: (result) => {
                    this.pushPortfolioResult = result;
                    this.loading = false;
                },
                error: (error) => {
                    this.errors = error.error.errorDetails.map((err) => {
                        let errorMessage = IREBAL_PUSH_ERROR_MESSAGES[err.error_code];
                        if (err.error_code === 'unrecognized_security') {
                            errorMessage += err.invalid_securities;
                        }
                        return errorMessage;
                    });
                    if (this.errors == null) {
                        this.errors = [
                            'There was an error pushing the portfolio to iRebal. Please contact support.',
                        ];
                    }
                    this.loading = false;
                },
            });
        }
    }
    get portfolioType() {
        switch (this.pushPortfolioResult?.integrationModelType) {
            case IREBAL_MODEL:
                return 'Model';
            case IREBAL_BLENDED_MODEL:
                return 'Blended Model';
            default:
                return 'Portfolio';
        }
    }
    get iRebalPortfolioID() {
        return this.pushPortfolioResult ? this.pushPortfolioResult.integrationModelId.toString() : '';
    }
    get cancelButtonText() {
        return this.pushPortfolioResult || this.errors ? 'Close' : 'Cancel';
    }
    get showSubmitButton() {
        return !this.loading && !this.errors && !this.pushPortfolioResult;
    }
}
IRebalPushModal.ɵfac = function IRebalPushModal_Factory(t) { return new (t || IRebalPushModal)(i0.ɵɵdirectiveInject(i1.SchwabIntegrationService), i0.ɵɵdirectiveInject(i2.Store)); };
IRebalPushModal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IRebalPushModal, selectors: [["ycn-irebal-push-modal"]], decls: 9, vars: 9, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], [1, "modal-section"], ["class", "form-row text-red", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "submitButtonText", "showSubmitButton"], [3, "loaderMessage"], [1, "form-row", "text-red"], ["class", "text-red", 4, "ngFor", "ngForOf"], [1, "text-red"], [1, "bullet-none"], [1, "form-row"], [1, "form-label"], [1, "form-control", "field-input", 3, "focus", "ngModelChange", "placeholder", "ngModel", "ngClass"]], template: function IRebalPushModal_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function IRebalPushModal_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function IRebalPushModal_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, IRebalPushModal_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, IRebalPushModal_div_5_Template, 3, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, IRebalPushModal_div_6_Template, 6, 5, "div", 6)(7, IRebalPushModal_div_7_Template, 3, 2, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-simple-modal-footer", 7);
        i0.ɵɵlistener("cancelHandler", function IRebalPushModal_Template_ycn_simple_modal_footer_cancelHandler_8_listener() { return ctx.closeModal(); })("submitHandler", function IRebalPushModal_Template_ycn_simple_modal_footer_submitHandler_8_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Push portfolio to iRebal");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errors);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && !ctx.pushPortfolioResult && !ctx.errors);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.pushPortfolioResult != null && !ctx.errors);
        i0.ɵɵadvance();
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButtonText)("submitButtonText", "Push")("showSubmitButton", ctx.showSubmitButton);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent, i8.LoadingSymbolComponent], encapsulation: 2 });
